<div class="dialog-container">
  <mat-card class="no-shadow">
    <mat-card-header>
      <mat-card-title class="no-subtitle">Routing Information</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <app-data-box headerTitle="Notes" class="mt-32">
        <div class="data-box-content">
          <ul>
            <li>Only <span class="font-bold">today's</span> routing is displayed.</li>
            <li>Times are <span class="font-bold">OFF/ON</span> local to station.</li>
          </ul>
        </div>
      </app-data-box>
      <app-data-box headerTitle="Icons" class="mt-32">
        <div class="icons-container data-box-content">
          <div class="flex-center p-8">
            <mat-icon class="success-color icon-text-right">task_alt</mat-icon>
            Landed
          </div>
          <div class="flex-center p-8">
            <mat-icon class="info-color icon-text-right">flight_takeoff</mat-icon>
            In flight
          </div>
          <div class="flex-center p-8">
            <mat-icon class="opacity-4 icon-text-right">schedule</mat-icon>
            Scheduled
          </div>
        </div>
      </app-data-box>
    </mat-card-content>
  </mat-card>
</div>